import { Building2, Mail, MapPin, Phone } from "lucide-react";
import { BRAND } from "@/data/content";

export function ContactSection({ t, lang }) {
    const serviceArea = lang === "fr" ? BRAND.serviceAreaFr : BRAND.serviceAreaEn;
    return (
        <section id="contact" className="section contact-section" data-testid="reset365-contact-section">
            <div className="page-width">
                <div className="contact-heading reveal">
                    <p className="eyebrow" data-testid="reset365-contact-eyebrow">{t.eyebrow}</p>
                    <h2 data-testid="reset365-contact-title">{t.title}</h2>
                    <p>{t.tagline}</p>
                </div>
                <div className="contact-grid">
                    <a href={BRAND.phoneHref} className="contact-detail reveal" data-testid="reset365-contact-phone">
                        <span className="contact-detail__icon"><Phone size={20} aria-hidden="true" /></span>
                        <span><small>{t.phoneLabel}</small><strong>{BRAND.phone}</strong></span>
                    </a>
                    <a href={BRAND.emailHref} className="contact-detail reveal" data-testid="reset365-contact-email">
                        <span className="contact-detail__icon"><Mail size={20} aria-hidden="true" /></span>
                        <span><small>{t.emailLabel}</small><strong>{BRAND.email}</strong></span>
                    </a>
                    <div className="contact-detail reveal" data-testid="reset365-contact-address">
                        <span className="contact-detail__icon"><Building2 size={20} aria-hidden="true" /></span>
                        <span><small>{t.addressLabel}</small><strong>{BRAND.address}</strong></span>
                    </div>
                    <div className="contact-detail reveal" data-testid="reset365-contact-area">
                        <span className="contact-detail__icon"><MapPin size={20} aria-hidden="true" /></span>
                        <span><small>{t.areaLabel}</small><strong>{serviceArea}</strong></span>
                    </div>
                </div>
                <div className="contact-actions reveal">
                    <a href={BRAND.phoneHref} className="button button--primary" data-testid="reset365-contact-call-btn">{t.call}</a>
                    <a href={BRAND.emailHref} className="button button--outline" data-testid="reset365-contact-email-btn">{t.email}</a>
                </div>
            </div>
        </section>
    );
}
